import IMInventory from './IMInventory';

export default IMInventory;
